import { cn } from '../../lib/utils';

/** Seamless infinite marquee. Duplicates children and translates -50%. */
export default function Marquee({ children, className, slow = false, reverse = false }) {
  const track = cn(
    'flex shrink-0 items-center gap-8 pr-8',
    slow ? 'animate-marquee-slow' : 'animate-marquee',
    reverse && '[animation-direction:reverse]',
    'group-hover:[animation-play-state:paused]'
  );
  return (
    <div className={cn('group flex overflow-hidden', className)}>
      <div className={track}>{children}</div>
      <div className={track} aria-hidden>
        {children}
      </div>
    </div>
  );
}
